$w.onReady(function () {

	$w('#Btn2020').onClick(() => {
		$w('#statebox').changeState("2020State");
	});
	$w('#Btn2021').onClick(() => {
		$w('#statebox').changeState("2021State");
	});
});